import React, { Component, useEffect, useState } from "react";
import axios from "axios";
import { JSEncrypt } from "jsencrypt";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "universal-cookie";
import { login, getRequestPublicKey } from "../../services/index";
import { generateOTP, handleVerifyOtp } from "../../services/Login/LoginService";
import { error } from "jquery";
import { callPostApi } from "../../services/common/common";
import { GENERATEOTP_URL } from "../../CONSTANTS";

const LoginComponent = () => {
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneFlag, setPhoneFlag] = useState(false);
    const [otp, setOtp] = useState("");
    const [enterOtp, setEnterOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false)
    const [otpCooldown, setOtpCooldown] = useState(0)

    let LC = localStorage.getItem("rememberUserLogin");

    let rememberUserLogin;
    if (LC) {
        rememberUserLogin = JSON.parse(localStorage.getItem("rememberUserLogin"));
    }

    // const [username, setUsername] = useState(rememberUserLogin?.username);
    // const [password, setPassword] = useState(rememberUserLogin?.password);

    // const handleKeyPress = (event) => {
    //     if (event.key === "Enter") {
    //         handleClick();
    //     }
    // };
    // const handleKeyDown = (event) => {
    //     console.log(event.key);
    // };
    // const handleUserChange = (e) => {
    //     setUsername(e.target.value);
    // };
    // const handlePassChange = (e) => {
    //     setPassword(e.target.value);
    // };

    const handleMobile = (e) => {
        const limitedValue = e.target.value.slice(0, 10);
            setPhoneNumber(limitedValue)
    }

    useEffect(() => {
        if (otpCooldown <= 0) return;
        const timer = setTimeout(() => setOtpCooldown(otpCooldown - 1), 1000);
        return () => clearTimeout(timer);
    }, [otpCooldown]);

    const handleSendOtp = () => {
        if (otpCooldown > 0) return;
        if (phoneNumber.length < 10) {
            toast("Invalid Number!!");
            return;
        }

        const data = {
            isdCode: "+91",
            mobileNumber: phoneNumber,
        }
        callPostApi(GENERATEOTP_URL(), data, {}, (response) => {
            if (response.errorCode === 0) {
                setOtpSent(true);
                setOtpCooldown(30);
                toast.success(response.message);
            } else {
                toast.error(response.message);
            }
        }, (err) => {
            toast.error("Something went wrong!!", err)
        })
    }


    const handleClick = (event) => {

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const timeout = setTimeout(() => {
            source.cancel();
            // setLoading(false);
            toast("🙁 Server is not responding kindly try again later!!");
        }, 20000);
        if (!phoneNumber) {
            toast.error("Phone number not found");
            return;
        }
        if (!otp) {
            toast.error("OTP not found");
            return;
        }
        if (otp.length !== 4) {
            toast.error("Invalid OTP length");
            return;
        }
        setLoading(true);
        // if(otp.length === 3){
        //     toast.error("Invalid OTP");
        //     return;
        // }
        // login()
        getRequestPublicKey().then((res) => {
            clearTimeout(timeout);
            if (res.errorCode == 0) {
                var publicKey = res.responsePacket;
                const encrypt = new JSEncrypt();
                encrypt.setPublicKey(publicKey);
                // let encryptedPassword = encrypt.encrypt(password);
                // // var payload = {
                //   username: username,
                //   password: encryptedPassword,
                // };
              
                const payload = {
                    isdCode: "+91",
                    mobileNumber: phoneNumber,
                    oneTimePassword: otp
                }
                handleVerifyOtp(payload).then((res) => {

                    if (res.errorCode == 0) {
                        var loginData1 = res.responsePacket;
                        // set cookie object here
                        const cookies = new Cookies();
                        let d = new Date();

                        d.setTime(d.getTime() + 9 * 60 * 60 * 1000);
                        cookies.set("loginData1", loginData1, { path: "/", expires: d });
                        cookies.set("pyAuth", loginData1.accessToken, {
                            path: "/",
                            expires: d,
                        });
                        toast.success("Login Successfully");

                        setTimeout(function () {
                            window.location.reload(24);
                        }, 1000);
                    } else {
                        var errorMsg = res.message;
                        toast.error(errorMsg);
                        setLoading(false);
                    }
                });
            } else {
                var errorMsg = res.message;
                toast.error(errorMsg);
            }
        });
    };

    // const handleForgotPassword = () => { };

    // const handleRemember = () => {
    //     const rememberUserLogin = {
    //         // username: username,
    //         // password: password,
    //         mobileNumber: phoneNumber,
    //         oneTimePassword: otp
    //     };

    //     localStorage.setItem(
    //         "rememberUserLogin",
    //         JSON.stringify(rememberUserLogin)
    //     );
    // };

    const handleOTP = (e) => {
        const { value } = e.target;
        if (value.length <= 4) {
            setOtp(value);
            setEnterOtp(value);
        }
    }

    useEffect(()=>{
    if(otp && otp.length === 4){
        handleClick()
    }
    },[otp])

    const handleResendOtp = () => {
        if (otpCooldown > 0) return;
        setOtp('');
        setEnterOtp('');
        handleSendOtp();
    }

    return (
        <>
            <div className="auth-main2 particles_js">
                <div className="auth_div vivify fadeInTop">
                    <div className="card">
                        <div className="body">
                            <div className="login-img">
                                <img
                                    className="img-fluid"
                                    src="https://s3.ap-south-1.amazonaws.com/crypto-pro-bucket/client-bucket-bww/primary-image/1626166429329_loginimg.png"
                                />
                            </div>
                            <div className="form-auth-small">
                                <div className="mb-3">
                                    <p className="lead">Login to your account</p>
                                </div>
                                <div className="form-group custom-mo po">
                                    <span className="input-group-addon ">+ 91</span>
                                    <input type="number" className="form-control round" placeholder="Enter Mobile Number..." onChange={(e) => handleMobile(e)} value={phoneNumber} />
                                    <button className="send-otp" onClick={handleSendOtp} disabled={otpCooldown > 0} style={otpCooldown > 0 ? { opacity: 0.6, cursor: "not-allowed" } : {}}>
                                        {otpCooldown > 0 ? `Wait ${otpCooldown}s` : "Send Otp"}
                                    </button>
                                </div>

                                <div className="otp-spin">
                                    <input type="number"
                                        className="form-control round"
                                        placeholder="Enter OTP..."
                                        onChange={(e) => handleOTP(e)}
                                        value={enterOtp}
                                        disabled={!otpSent}
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="signin-email"
                                        className="control-label sr-only"
                                    >
                                        MobileNumber
                                    </label>
                                    {/* <input
                                        type="email"
                                        className="form-control round"
                                        id="signin-email"
                                        disabled={loading}
                                        value={mobileNumber}
                                        placeholder="User Name"
                                        onKeyDown={handleKeyDown}
                                        onKeyPress={handleKeyPress}
                                        onChange={handleUserChange}
                                    /> */}
                                </div>
                                {/* <div className="form-group">
                                    <label
                                        htmlFor="signin-password"
                                        className="control-label sr-only"
                                    >
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control round"
                                        id="signin-password"
                                        disabled={loading}
                                        value={password}
                                        placeholder="Password"
                                        onKeyPress={handleKeyPress}
                                        onChange={handlePassChange}
                                    />
                                </div> */}
                                <div className="text-center">
                                    <label className="fancy-checkbox element-center cursor-pointer">
                                        <span onClick={handleResendOtp} style={otpCooldown > 0 ? { opacity: 0.5, cursor: "not-allowed" } : { cursor: "pointer" }}>
                                            {otpCooldown > 0 ? `Resend OTP (${otpCooldown}s)` : "Resend OTP"}
                                        </span>
                                    </label>
                                </div>
                                {/* <div className="form-group my-2">
                  <div className="passcode-wrapper custom-padding-otp justify-content-center">
                    <form>
                      <input
                        type="number"
                        max={1}
                        min={1}
                        name="otp0"
                        tabIndex={0}
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        defaultValue=" "
                      />
                      <input
                        type="number"
                        max={1}
                        min={1}
                        name="otp1"
                        tabIndex={1}
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        defaultValue=" "
                      />
                      <input
                        type="number"
                        max={1}
                        min={1}
                        name="otp2"
                        tabIndex={2}
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        defaultValue=" "
                      />
                      <input
                        type="number"
                        max={1}
                        min={1}
                        name="otp3"
                        tabIndex={3}
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        defaultValue=" "
                      />
                    </form>
                  </div>
                  <p className="text-white mb-0 mt-2">Enter OTP sent to your Phone Number.</p>
                </div> */}
                                <button
                                    type="submit"
                                    onClick={handleClick}
                                    className="btn btn-primary btn-round btn-block"
                                >
                                    {loading && (
                                        <i
                                            className="fa fa-refresh fa-spin"
                                            style={{ marginRight: "5px" }}
                                        />
                                    )}
                                    {loading && <span>LOGIN....</span>}
                                    {!loading && <span>LOGIN</span>}
                                </button>
                                {/* <div className="mt-4">
                  <span className="helper-text m-b-10">
                    <i className="fa fa-lock"></i>{" "}
                    <a
                      onClick={handleForgotPassword}
                      style={{ cursor: "pointer" }}
                    >
                      Forgot password?
                    </a>
                  </span>
                </div> */}
                            </div>
                            <div className="pattern">
                                <span className="red"></span>
                                <span className="indigo"></span>
                                <span className="blue"></span>
                                <span className="green"></span>
                                <span className="orange"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="particles-js">
                    <canvas
                        className="particles-js-canvas-el"
                        width="1898"
                        height="463"
                        style={{ width: "100%", height: "100%" }}
                    ></canvas>
                </div>
                <Toaster />
            </div>
        </>
    );
};

export default LoginComponent;
